export const _bannerClass = {
  name: { type: 'string', title: 'Bannerin nimi' },
  clickurl: { type: 'string', title: 'Kohde osoite' },
  start: {
    type: 'string',
    format: 'date',
    title: 'Ensimmäinen päivä jossa näkyy',
  },
  end: {
    type: 'string',
    format: 'date',
    title: 'Viimeinen päivä jossa näkyy',
  },
  categories: {
    type: 'string',
    format: 'string',
    title: 'Varausnäkymän kategoriat. Erottele pilkulla. Tyhjä = kaikki',
  },
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'active', title: 'Aktiivinen' },
      { const: 'paused', title: 'Pysäytetty' },
    ],
  },
}

export const _bannerUISchema = {}